module.exports = __webpack_public_path__ + "img/bde128be2ad317ae7546f4ae4d7a03c1.svg";